import EventEmitter from "base/EventEmitter";
import AjaxForm, {EVENT_SUCCESS} from "webPage/AjaxForm";

export default class QuizStep extends EventEmitter {
    constructor($element) {
        super();

        this.$element = $element;

        this.bindEvents();
    }

    bindEvents() {
        let me = this;

        this.form = new AjaxForm(this.$element, ($form, formData) => {
            return [formData];
        }).on(EVENT_SUCCESS, (data) => {
            if ('undefined' !== typeof data[0]['product_type']) {
                this.emit('updateIsShutters', data[0]['product_type'] === 'shutters');
            }

            this.emit('nextStep');
        });

        this.$element.on('click', '.js-previous', () => {
            this.emit('previousStep');
            return false;
        }).on('change', '.js-checkbox', function () {
            let $this = $(this);
            let checked = $this.is(":checked");

            if (checked) {
                $this.parents('.checkbox').addClass('checkbox--selected');
            } else {
                $this.parents('.checkbox').removeClass('checkbox--selected');
            }
        }).on('change', '.js-radio', function () {
            let $this = $(this);
            let name = $this.attr('name');

            me.$element.find('.js-radio[name="' + name + '"]').parents('.radio').removeClass('radio--selected');
            me.$element.find('.js-radio[name="' + name + '"]:checked').parents('.radio').addClass('radio--selected');

        });
    }

    getData() {
        return this.form.getFormData();
    }
}